import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import spacing from '@decisiv/design-tokens/lib/spacing';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto 1fr 1fr;
  grid-gap: 5px;
  width: 100%;
`;

export const SeverityCount = styled.div`
  margin-left: ${rem(spacing.base * 0.5)};
  display: inline-block;
`;
